import moment from 'moment';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import applicantActions from './actions';
import { tableConfig } from '../../../settings/index';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import Api, { executeAction } from '../../../helpers/api';
import { withTZ } from '../../../helpers/dateTime';

const api = new Api('interviews');
const applicantsListApi = new Api('interviews/applicants_list');
const assignApplicantApi = new Api('interviews/:id/assign_applicant');
const videoInterviewApi = new Api('interviews/:interview_id/start_video');

const getTime = (date, time) => {
  const hours = moment(time, 'hh:mma').get('hours');
  const minutes = moment(time, 'hh:mma').get('minutes');

  const final = withTZ(moment(date).add(hours, 'hours').add(minutes, 'minutes')).format();

  return final;
};

function* startVideoInterview({ payload }) {
  try {
    const { id } = payload;

    yield call(
      sendRequest,
      videoInterviewApi.updateItem,
      {
        id,
      },
      notifications.REQUEST_ERROR,
    );
  } catch (error) {
    logger.error(error);
  }
}

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.maxPageSize, column, order, time_from, time_to, schedule_time } = payload;
    let { state = [], city = [], district = [], location = [] } = payload;

    if (!Array.isArray(state)) {
      state = [state];
    }

    if (!Array.isArray(city)) {
      city = [city];
    }

    if (!Array.isArray(district)) {
      district = [district];
    }

    if (!Array.isArray(location)) {
      location = [location];
    }
    const interview_date = withTZ(time_from).toISOString();
    const search = { page, pageSize, column, order, state, city, district, interview_date, location };

    if (schedule_time && schedule_time.time_from && schedule_time.time_to) {
      search['schedule_time[time_from]'] = getTime(time_from, schedule_time.time_from);
      search['schedule_time[time_to]'] = getTime(time_from, schedule_time.time_to);
    } else {
      search['schedule_time[time_from]'] = time_from;
      search['schedule_time[time_to]'] = time_to;
    }
    const result = yield call(sendRequest, api.load, { search }, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortable_columns, actions, filters } = result.data.success.data;

      const data = {
        data: records,
        total: totalCount,
        filteredTotal: filteredCount,
        sortableColumns: sortable_columns,
        actions,
        filters,
      };

      if (!schedule_time || !schedule_time.time_from || !schedule_time.time_to) {
        data.filters.map(filter => {
          if (filter.name === 'schedule_time') {
            filter.activeFilters = {};
            filter.filterOptions = {};
          }

          return filter;
        });
      } else {
        data.filters.map(filter => {
          if (filter.name === 'schedule_time') {
            filter.activeFilters = {
              time_from: withTZ(filter.activeFilters.time_from),
              time_to: withTZ(filter.activeFilters.time_to),
            };
            filter.filterOptions = {
              time_from: withTZ(filter.filterOptions.time_from),
              time_to: withTZ(filter.filterOptions.time_to),
            };
          }

          return filter;
        });
      }
      yield put(applicantActions.loadDataSuccess(data));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadApplicantsList({ payload }) {
  try {
    const { full_name } = payload;
    const result = yield call(
      sendRequest,
      applicantsListApi.load,
      { search: { filter: full_name } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      yield put(applicantActions.loadApplicantsListSuccess({ applicants: result.data.success.data.records }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* checkInApplicant({ payload }) {
  try {
    const { interview, method, url, cb } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result) {
      yield put(applicantActions.checkInSuccess({ interview }));

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* removeCheckIn({ payload }) {
  try {
    const { interview, method, url, cb } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result) {
      yield put(applicantActions.checkInSuccess({ interview }));

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* onNoShowAction({ payload }) {
  try {
    const { method, url, cb } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result) {
      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* onUndoNoShowAction({ payload }) {
  try {
    const { method, url, cb } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result) {
      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* processAction({ payload }) {
  try {
    const { method, url } = payload;

    yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);
  } catch (error) {
    logger.error(error);
  }
}

function* assignApplicant(data) {
  try {
    const { applicant_id, interview_id, cb } = data.payload;
    const result = yield call(
      sendRequest,
      assignApplicantApi.updateItem,
      {
        data: { applicant_id },
        id: interview_id,
      },
      notifications.REQUEST_ERROR,
    );

    if (result && cb) {
      cb();
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(applicantActions.ASSIGN_APPLICANT, assignApplicant),
    takeEvery(applicantActions.CHECK_IN, checkInApplicant),
    takeEvery(applicantActions.REMOVE_CHECK_IN, removeCheckIn),
    takeEvery(applicantActions.LOAD, loadData),
    takeEvery(applicantActions.LOAD_APPLICANTS_LIST, loadApplicantsList),
    takeEvery(applicantActions.NO_SHOW_ACTION, onNoShowAction),
    takeEvery(applicantActions.UNDO_NO_SHOW_ACTION, onUndoNoShowAction),
    takeEvery(applicantActions.START_VIDEO_INTERVIEW, startVideoInterview),
    takeEvery(applicantActions.PROCESS_ACTION, processAction),
  ]);
}
